import React from "react";
import SelectInput from "common/SelectInput";
import PasswordInput from "common/PasswordInput";
import NonBlockingStatus, {Grouped} from "../Common/NonBlockingStatus";
import SwitchInput from "common/SwitchInputWithState";


const sonarBillingSubscribers = [
  { label: "Leave unchanged", value: "unchanged" },
  { label: "Customer ID", value: "customer-id" },
  { label: "Name", value: "name" },
];

const sonarDelinquentOptions = [
  { label: "Sonar Status", value: false },
  { label: "Sonar Delinquency state", value: true },
];

const PolicyNameFromSonarInput = ({
  onChange,
  defaults = {},
  className = "",
}) => (
  <>
    <SwitchInput
      defaultChecked={defaults.sonarPolicyName}
      className={className}
      name="sonarPolicyName"
      label="Policy names from Sonar service names"
      onChange={onChange}
    />
  </>
);

const SonarBillingSettings = ({ onChange, defaults = {}, state }) => (
  <>
    <PasswordInput
      defaultValue={defaults.apikey}
      className="input-group"
      name="apikey"
      label="API key"
      onChange={onChange}
    />
    <SelectInput
      label="Subscriber-ID source"
      name="subscriberIdSource"
      className="input-group"
      onChange={onChange}
      defaultValue={defaults.subscriberIdSource}
      options={sonarBillingSubscribers}
    />
    <Grouped>
      <SelectInput
        label="Blocking based on"
        name="sonarDelinquent"
        className="input-group column-prefer-left"
        onChange={(event) =>
          onChange(null, {
            name: "sonarDelinquent",
            value: event.target.value === "true",
          })
        }
        defaultValue={defaults.sonarDelinquent || false}
        options={sonarDelinquentOptions}
      />
      {state.sonarDelinquent === true ? null : (
        <NonBlockingStatus
          className="has-input-groups column-prefer-left"
          onChange={({ list }) =>
            onChange(null, { name: "sonarNonBlockingStatus", value: list })
          }
          state={state}
          defaults={{ list: defaults.sonarNonBlockingStatus || [] }}
        />
      )}
    </Grouped>
    <Grouped className="align-bottom">
      <PolicyNameFromSonarInput
        onChange={onChange}
        defaults={defaults}
        state={state}
        className="input-group"
      />
    </Grouped>
  </>
);

export default SonarBillingSettings;
